import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { vatColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import type { ApiVat } from '@Model';
import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { VatRepository } from '@Repositories/Stammdaten';

export function FrameListVat() {
    const hasPermission = useHasPermission();

    const module = useListApi(VatRepository, STAMMDATEN_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiVat>
            layoutSettingsContext={EnumFrontendLayoutSetting.VatsTableLayout}
            name="VatList"
            columns={vatColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.StammdatenVatCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
